import React from "react"
import { alertShow } from "../config/Helpers";

class Alerts extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            rows_models  : "",
            rows_reports : ""
        }
    }

    handleClick(type){
        this.props.alertState(type)
    }
    render(){
        return (
            <div className={"container-alerts " + alertShow(this.props)}>
                <div className={"alert-datepicker-error " + this.props.alert_datepicker_error}>
                    <p>SELECCIONE FECHAS CORRECTAS</p>
                    <a onClick={this.handleClick.bind(this,"datepicker")} href="#">CERRAR</a>
                </div>
            </div>
        )
    }
}

export default Alerts


// WEBPACK FOOTER //
// ./src/Frontend/components/Alerts.js